import React, { useState } from "react";
import "./Dialog.css";
import Button from "@mui/material/Button";
import MuiDialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CloseIcon from "@mui/icons-material/Close";
import DialogContentText from "@mui/material/DialogContentText";
import { Divider, Stack } from "@mui/material";
import Slide from "@mui/material/Slide";
import { Colors } from "../Styles/Colors";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function DialogBox({ type, DialogClose, header, content, icon, primary, secondary, yesButton, closeButton }) {
  const [open] = useState(true);

  const handleClose = () => {
    DialogClose();
  };

  return (
    <div className="eMed_Dialog">
      <MuiDialog TransitionComponent={Transition} open={open} PaperProps={{ sx: { width: "40%" } }}>
        <DialogTitle sx={{ bgcolor: Colors.TableHeaderBarBGColor, color: Colors.TableHeaderTextColor }}>
          <div className="eMed_dialogHead">
            <div id="eMed_Dialog_title">{header}</div>
            <div className="eMed_cancel">
              <CloseIcon onClick={handleClose} />
            </div>
          </div>
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ bgcolor: Colors.PopupBackground }}>
          <div className="eMed_dialogBody">
            <div className="eMed_dialogbodyContent">
              <DialogContentText>{icon}</DialogContentText>
            </div>
            <div className="eMed_dialogbodyContent">
              <DialogContentText>{content}</DialogContentText>
            </div>
          </div>
        </DialogContent>
        <Divider />
        {type !== "loginsucess" && (
          <DialogActions id="eMed_dlgBtn" sx={{ bgcolor: Colors.PopupBackground }}>
            {type !== "Notification" && primary && secondary && (
              <Stack spacing={2} direction="row">
                {yesButton && (
                  <Button variant="contained" onClick={() => { handleClose(); yesButton(); }}>
                    {primary}
                  </Button>
                )}
                <Button variant="outlined" onClick={handleClose}>
                  {secondary}
                </Button>
              </Stack>
            )}
            {type === "Notification" && (
              <Button variant="outlined" onClick={() => { handleClose(); closeButton?.(); }}>
                {secondary}
              </Button>
            )}
          </DialogActions>
        )}
      </MuiDialog>
    </div>
  );
}

export default DialogBox;
